import { render, staticRenderFns } from "./ProductsToOrder.vue?vue&type=template&id=3648cb96&scoped=true"
import script from "./ProductsToOrder.vue?vue&type=script&lang=js"
export * from "./ProductsToOrder.vue?vue&type=script&lang=js"
import style0 from "./ProductsToOrder.vue?vue&type=style&index=0&id=3648cb96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3648cb96",
  null
  
)

export default component.exports